import './experience.style.css'
import { GoVerified } from 'react-icons/go'
import { frontendSkills, backendSkills } from '../../utils/config'
const Expereince = () => {
  return (
    <section id="experience">
      <h5>What's Skill I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            {frontendSkills.map((s) => (
              <article className="experience_detail" key={s}>
                <GoVerified />
                <div className="skill">
                  <h4>{s.skill}</h4>
                  <small className="text-light">{s.expLevel}</small>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="experience_backend">
          <h3>Backend Development</h3>
          <div className="experience_content">
            {backendSkills.map((s) => (
              <article className="experience_detail" key={s}>
                <GoVerified />
                <div className="skill">
                  <h4>{s.skill}</h4>
                  <small className="text-light">{s.expLevel}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Expereince
